import React from 'react';

import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import { runCreditCheck, getCreditReportStatus } from 'actions/landlordApplicationsActions';

import { SyncLoader } from 'halogenium';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

const CREDIT_CHECK_POLL_INTERVAL = 7500;

const TenantCreditCheck = class extends React.Component {
  state = { dialogOpen: false, isProcessing: false };

  componentDidMount() {
    if (this.props.creditCheckIsAnalyzing !== true) return;

    this.props.getCreditReportStatus(this.props.leadId).then(response => {
      if (response.value.status !== 'returned') {
        let retrieveCreditReportInterval = setInterval(() => {
          this.props.getCreditReportStatus(this.props.leadId).then(response => {
            if (response.value.status === 'returned') {
              clearInterval(retrieveCreditReportInterval);
              this.setState({ isSubmitting: false, dialogOpen: false, isProcessing: false });
              this.props.getApplication();
            }
          });
        }, CREDIT_CHECK_POLL_INTERVAL);
      } else {
        this.setState({ isSubmitting: false, dialogOpen: false, isProcessing: false });
        this.props.getApplication();
      }
    });
  }

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen, isSubmitting: false });
  };

  creditCheckInterval = leadId => {
    let retrieveCreditReportInterval = setInterval(() => {
      this.props.getCreditReportStatus(leadId).then(response => {
        if (response.value.status === 'returned') {
          clearInterval(retrieveCreditReportInterval);
          this.setState({ isSubmitting: false, dialogOpen: false, isProcessing: false });
          this.props.getApplication();
        }
      });
    }, CREDIT_CHECK_POLL_INTERVAL);
  };

  runCreditCheck = leadId => {
    this.setState({ isSubmitting: true, isProcessing: true });
    this.props.runCreditCheck(leadId).then(success => {
      if (success.value) {
        this.creditCheckInterval(leadId);
      } else {
        this.setState({ isSubmitting: false, dialogOpen: true, isProcessing: false });
      }
    });
  };

  render() {
    if (!this.props.showCreditReport) return null;

    return (
      <div>
        <Dialog
          disableBackdropClick
          fullScreen={this.props.fullScreen}
          modal
          open={this.state.dialogOpen}
          onClose={this.toggleDialog}
          aria-labelledby="run-credit-report"
          classes={{
            paper: 'form-dialog',
          }}
        >
          {this.state.isSubmitting && (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                background: 'white',
                zIndex: '10',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div className="col-xs-12" style={{ textAlign: 'center' }}>
                <SyncLoader color={AccentColor()} size="16px" margin="auto" />
                <div className="col-xs-12" style={{ marginTop: '10px' }}>
                  <p style={{ textAlign: 'center' }}> Please wait while we retrieve your report </p>
                </div>
              </div>
            </div>
          )}
          <DialogTitle id="add-new-journal-entry">
            <h3 style={{ textAlign: 'center', margin: 0 }}>Run Credit Check</h3>
          </DialogTitle>
          <DialogContent>
            <p>
              You will be re-directed to our new credit check functionality on the details page of
              the application. You will be able to select and modify your credit check types.
            </p>
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              CLOSE
            </FlatButton>
            <FlatButton
              onClick={() =>
                browserHistory.push(
                  `/companies/applications/${this.props.applicationID}?drawer_page=details`
                )}
              disabled={this.state.isSubmitting}
              id="submit-button"
              style={{
                color: 'white',
                backgroundColor: this.state.isSubmitting ? colors.LIGHT_GRAY : AccentColor(),
              }}
            >
              Continue
            </FlatButton>
          </DialogActions>
        </Dialog>

        <div className="row" style={{ padding: '0 20px' }}>
          {this.props.creditCheck &&
            !this.state.isProcessing &&
            !this.props.creditCheckIsAnalyzing && (
              <div className="col-xs-12" style={{ textAlign: 'center' }}>
                <h5>
                  <a href={this.props.creditCheck} target="_blank" rel="noopener noreferrer">
                    {' '}
                    View Credit Report{' '}
                  </a>
                </h5>
              </div>
            )}
          {!this.props.creditCheck &&
            !this.state.isProcessing &&
            !this.props.creditCheckIsAnalyzing && (
              <div className="col-xs-12" style={{ textAlign: 'center' }}>
                <FlatButton
                  label="Run Credit Check"
                  primary={true}
                  style={{ backgroundColor: AccentColor(), color: '#fff' }}
                  onClick={this.toggleDialog}
                />
              </div>
            )}
          {(this.props.creditCheckIsAnalyzing || this.state.isProcessing) && (
            <div className="col-xs-12" style={{ textAlign: 'center' }}>
              <h5>A Credit Check is in Progress</h5>
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default connect(null, { runCreditCheck, getCreditReportStatus })(TenantCreditCheck);
